/** @format */

import { propertyMap } from 'model-mapper';
import { EquipmentTagType } from '../../../../../../dist/sesio-lib';

export class CreateEquipmentRequestDto {
  @propertyMap({ source: 'organizationalUnit.code' })
  groupReference: string;

  @propertyMap({ source: 'realEstateStructure.reference' })
  esi: string;

  @propertyMap({ source: 'kind.id' })
  equipmentKindReference: string;

  @propertyMap({ source: 'contractor.id' })
  contractorId: string;

  @propertyMap({ source: 'externalReference' })
  externalEquipmentReference: string;

  @propertyMap({ source: 'tagType' })
  equipmentTagType: EquipmentTagType;

  @propertyMap({ source: 'tagCode' })
  equipmentTagCode: string;

  @propertyMap()
  comment: string;

  @propertyMap()
  state: number;

  @propertyMap()
  location?: string;
}

export class UpdateEquipmentRequestDto {
  @propertyMap({ source: 'contractor.id' })
  contractorId: string;

  @propertyMap({ source: 'externalReference' })
  externalEquipmentReference: string;

  @propertyMap({ source: 'tagType' })
  equipmentTagType: EquipmentTagType;

  @propertyMap({ source: 'tagCode' })
  equipmentTagCode: string;

  @propertyMap()
  comment: string;

  @propertyMap()
  state: number;

  @propertyMap()
  location?: string;
}
